import React from "react";

const DocumentationServiceContext = React.createContext(null);

export default DocumentationServiceContext;
